import type { Messages } from '@/shared/i18n/de';

/**
 * Cross-portal (shared chrome) messages — English. Typed against the German
 * reference, so a missing or misspelled key fails the build.
 */
const en: Messages = {
  login: {
    welcomeBack: 'Welcome back',
    customerPortal: 'Customer Portal',
    lead: 'Sign in to access your customer account.',
    username: 'Username',
    password: 'Password',
    forgotPassword: 'Forgot?',
    signingIn: 'Signing in…',
    signIn: 'Sign in',
    notCustomerYet: 'Not a customer yet?',
    requestAccess: 'Request access →',
    brandTag: 'Factory Innovation Award 2023–2025',
    headline: 'One portal for tickets, licenses, downloads and billing.',
    subline: 'Everything you need to run software4production across your sites — in one place, always up to date.',
    imprint: 'Imprint',
    privacy: 'Privacy',
    errorInvalidCredentials: 'Invalid username or password',
    errorGeneric: 'Login failed. Please try again.',
  },
  session: {
    expiredHeader: 'Session expired',
    expiredMessage: 'Your session has expired. Please sign in again.',
    toLogin: 'Go to sign-in',
  },
  language: {
    label: 'Language',
    de: 'German',
    en: 'English',
  },
  appShell: {
    profile: 'Profile',
    signOut: 'Sign out',
    help: 'Help',
    notifications: 'Notifications',
    toggleSidebar: 'Toggle sidebar',
  },
};

export default en;